import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { TipHeading } from "./TipHeading";
import { TipText } from "./TipText";
export const SeventhTip = (param)=>{
    let { children , headingClassName  } = param;
    return /*#__PURE__*/ _jsxs("article", {
        className: "min-w-[300px]",
        children: [
            children,
            /*#__PURE__*/ _jsx(TipHeading, {
                className: headingClassName,
                children: "Leave no trace"
            }),
            /*#__PURE__*/ _jsxs("ul", {
                className: "list-disc list-inside",
                children: [
                    /*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx(TipText, {
                            children: "Depictions of trashing our treasures are a no-go."
                        })
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx(TipText, {
                            children: "Leave what you find. No touching or taking cultural, historical or natural artifacts."
                        })
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx(TipText, {
                            children: "Respect wildlife. If you want to get gored by a bison – post that on TikTok."
                        })
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx(TipText, {
                            children: "Be considerate of others."
                        })
                    })
                ]
            })
        ]
    });
};
